/**
 *  设计文档: http://cooder.linkdoc.com:9999/fe/lk-admin/issues/8
 */

let logFn;
export function onLog(fn) {
  logFn = fn;
}

function log(...args) {
  logFn && logFn(...args);
}


export function parse(exp) {
  const G = {
    Exp(exp) {
      return this.RuleOr(exp);
    },

    RuleOr(exp) {
      const args = exp.split(/\s*\|\s*/g).map(x => this.RuleAnd(x));

      return args.length > 1 ? {
        type: 'anyRule',
        args,
      } : args[0];
    },

    RuleAnd(exp) {
      const args = exp.split(/\s*&\s*/g).map(x => this.RuleTerm(x));

      return args.length > 1 ? {
        type: 'allRule',
        args,
      } : args[0];
    },

    RuleTerm(exp) {
      return this.NsRule(exp);
    },

    NsRule(exp) {
      const index = exp.indexOf('::');
      if (index > -1) {
        const ns = exp.substring(0, index);
        const np = exp.substring(index + 2);

        return {
          type: 'nsRule',
          ns: this.Ns(ns),
          rule: this.NamePath(np),
        };
      } else {
        return this.Rule(exp);
      }
    },

    Ns(exp) {
      return this.NamePath(exp, 'nsPath');
    },

    NamePath(exp, type = 'namePath') {
      return {
        type,
        path: exp.split(/\s*\/\s*/g).map(x => this.NameExp(x)),
      };
    },

    Rule(exp) {
      return {
        type: 'rule',
        rule: this.NamePath(exp),
      };
    },

    NameExp(exp) {
      return this.NameOr(exp);
    },

    NameOr(exp) {
      const args = exp.split(/\s*,\s*/g).map(x => this.NameAnd(x));

      return args.length > 1 ? {
        type: 'anyName',
        args,
      } : args[0];
    },

    NameAnd(exp) {
      const args = exp.split(/\s*\+\s*/g).map(x => this.NameTerm(x));

      return args.length > 1 ? {
        type: 'allName',
        args,
      } : args[0];
    },

    NameTerm(exp) {
      return {
        type: 'name',
        name: exp.trim(),
      };
    },
  };

  return G.Exp(exp);
}


export function exec(ast, {env, ctx = {}, onNode}) {
  const runCtx = {
    ctx,
    run,
    env,
  };

  const defaultFn = env['*'];

  function run(node, ...args) {
    let {[node.type]: fn = defaultFn} = env;

    if (onNode) {
      onNode(node, fn, args)
    }

    if (fn) {
      return fn.call(runCtx, node, ...args);
    }
  }

  return runCtx.run(ast);
}



/*
 * ctx:
 *   ruleKey          - 'roles'
 *   data             - user.permissions
 *   isNsName         - name 是否应该解析为 namespace
 *   currentNsRule    - "a :: b" 中的 "b" (一般为 namePath)
 *   currentRuleData  - name 解析的时候读取的 对象
 *   isLastName       - name 是否是 namePath 中的最后一个
 *   currentNamePath  - x
 */
const baseEnv = {
  anyRule({args}) {
    for (let arg of args) {
      if (this.run(arg)) {
        return true;
      }
    }

    return false;
  },

  allRule({args}) {
    for (let arg of args) {
      if (!this.run(arg)) {
        return false;
      }
    }

    return true;
  },

  nsRule({ns, rule}) {
    // ns -> nsPath
    return this.run(ns, rule);
  },

  nsPath({path}, rule) {
    if (path.length !== 1) {
      throw new Error('only 1 level of resource allowed');
    }

    // 最后一级 path 上的 ns name 如果 match, 那么 '那个 ns 上的 roles' -> currentRuleData, 然后 运行 rule (a namePath)
    const nsName = path[0];

    this.ctx.currentNsRule = rule;
    this.ctx.isNsName = true;
    const ret = this.run(nsName);
    this.ctx.isNsName = false;
    this.ctx.currentNsRule = null;

    return ret;
  },

  rule({rule}) {
    if (rule.type !== 'namePath') {
      throw new Error('wrong rule');
    }

    this.ctx.currentRuleData = this.ctx.data[this.ctx.ruleKey];
    if (!this.ctx.currentRuleData) {
      return false;
    }

    return this.run(rule);
  },

  allName({args}) {
    for (let arg of args) {
      if (!this.run(arg)) {
        return false;
      }
    }

    return true;
  },

  anyName({args}) {
    for (let arg of args) {
      if (this.run(arg)) {
        return true;
      }
    }

    return false;
  },

  name({name}) {
    if (this.ctx.isNsName) {
      return this.env._nsName.call(this, name);
    } else {
      return this.env._nonNsName.call(this, name);
    }
  },

  _nsName(name) {
    const resource = name;
    const {resources} = this.ctx.data;

    if (!resources) {
      return false;
    }

    log('nsName ns:', resource);

    if (resource === '*') {
      const resourceKeys = Object.keys(resources);
      if (resourceKeys.length <= 0) {
        return false;
      }

      this.ctx.isNsName = false;
      for (let key of resourceKeys) {
        const obj = resources[key];

        this.ctx.currentRuleData = obj[this.ctx.ruleKey];
        const ret = this.run(this.ctx.currentNsRule);

        if (ret) {
          this.ctx.isNsName = true;
          return true;
        }
      }
      this.ctx.isNsName = true;

      return false;
    }

    const {[resource]: obj} = resources;

    if (!obj) {
      return false;
    }

    this.ctx.currentRuleData = obj[this.ctx.ruleKey];
    this.ctx.isNsName = false;
    const ret = this.run(this.ctx.currentNsRule);
    this.ctx.isNsName = true;

    return ret;
  },
};

const roleEnv = {
  ...baseEnv,

  namePath({path}) {
    if (path.length !== 1) {
      throw new Error('only 1 level of role allowed');
    }

    this.ctx.isLastName = true;
    return this.run(path[0]);
  },

  // role
  _nonNsName(name) {
    const role = name;
    const roles = this.ctx.currentRuleData;

    if (!roles) {
      return false;
    }

    log('check name', role, roles);

    if (role === '*') {
      return Object.keys(roles).length > 0;
    }

    return roles && roles[role] && true || false;
  },
};


export function checkRole(rule, user) {
  log(`checkRole "${rule}"`, user);

  const {permissions: data} = user;
  if (!data) {
    console.warn('no permissions in user');
    return false;
  }

  const ast = parse(rule);

  const ctx = {
    data,
    ruleKey: 'roles',
  };

  return exec(ast, {
    env: roleEnv,
    ctx,
    onNode(node, fn, args) {
      log(
        `checkRole run node "${node.type}": fn: ${fn ? 'Yes' : 'noFn'} args: node:`,
        JSON.stringify(node),
        'args:', args,
      );
    },
  });

}


const actionEnv = {
  ...baseEnv,

  namePath({path}) {
    if (path.length === 1) {
      path.unshift({
        type: 'name',
        name: '*',
      });
    } else if (path.length !== 2) {
      throw new Error('only 1 or 2 level of action allowed');
    }

    this.ctx.isLastName = false;
    this.ctx.currentNamePath = path;
    return this.run(path[0]);
  },

  // actions
  _nonNsName(name) {
    const action = name;
    const actions = this.ctx.currentRuleData;

    if (!actions) {
      return false;
    }

    log('check name', action, actions);

    if (this.ctx.isLastName) {
      if (action === '*') {
        return Object.keys(actions).length > 0;
      }

      return actions && actions[action] && true || false;

    }

    const checkLastName = (curMatch) => {
      const {isLastName, currentRuleData} = this.ctx;

      // save temp
      this.ctx.isLastName = true;
      this.ctx.currentRuleData = curMatch[this.ctx.ruleKey];

      const ret = this.run(this.ctx.currentNamePath[1]);

      // save back
      this.ctx.isLastName = isLastName;
      this.ctx.currentRuleData = currentRuleData;

      return ret;

    };

    if (action === '*') {
      const actionKeys = Object.keys(actions);
      if (actionKeys.length <= 0) {
        return false;
      }

      for (let key of actionKeys) {
        const ret = checkLastName(actions[key]);
        if (ret) {
          return true;
        }
      }

      return false;
    }

    const curMatch = actions && actions[action];
    if (!curMatch) {
      return false;
    }

    return checkLastName(curMatch);

  },
};


export function checkAction(rule, user) {
  log(`checkAction "${rule}"`, user);

  const {permissions: data} = user;
  if (!data) {
    console.warn('no permissions in user');
    return false;
  }

  const ast = parse(rule);

  const ctx = {
    data,
    ruleKey: 'actions',
  };

  return exec(ast, {
    env: actionEnv,
    ctx,
    onNode(node, fn, args) {
      log(
        `checkAction run node "${node.type}": fn: ${fn ? 'Yes' : 'noFn'} args: node:`,
        JSON.stringify(node),
        'args:', args,
      );
    },
  });

}


/*
 G {
 Expr
 =  RuleOr
 RuleOr
 =  RuleOr "|" RuleAnd
 |  RuleAnd
 RuleAnd
 =  RuleAnd "&" RuleTerm
 |  RuleTerm
 RuleTerm
 =  "(" RuleOr ")"
 |  NsRule
 NsRule
 = Ns "::" NamePath
 | Rule
 Rule
 =  NamePath
 Ns
 =  NamePath
 NamePath
 =  NamePath "/" NameExp
 |  NameExp
 NameExp
 =  NameOr
 NameOr
 =  NameOr "," NameAnd
 |  NameAnd
 NameAnd
 =  NameAnd "+" NameTerm
 |  NameTerm
 NameTerm
 =  "(" NameOr ")"
 |  Name
 Name
 =  Name alnum
 |  alnum
 }
 */

